import React, { useRef, useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { optionsEstadosSelect, optionsYesNoResponse } from "src/data/ConstantForm";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import { useDispatch } from "react-redux";
import { GlobalConstants } from "src/data/GlobalConstants";
import SelectFormVirtualize from "src/components/ComponentesFormularios/SelectFormVirtualize";
import { modalCRUDService } from "src/services/modalCRUDService";
import { dateToStringFormat, getFechaToCalendarRange } from "src/util/functions";
import { CalendarFormRange } from "src/components/ComponentesFormularios/CalendarForm";
import { gruposImpulsarService } from "src/services/unoauno/apiGruposImpulsar";

const FormCRUDGrupos = ({properties}) => {
    const dispatch = useDispatch();

    const { data: { 
        proveedor,
        data: dataGrupo,
        segmentaciones,
        edit,
        reload
    } } = properties;
    
    const methods = useForm({ defaultValues: { 
        nombre: edit ? dataGrupo.nombre : "",
        fecha: edit ? getFechaToCalendarRange(dataGrupo.fechaInicio, dataGrupo.fechaFin) : [new Date(), new Date()],
        asignaciones: edit ? dataGrupo.asignaciones : [],
        estado: edit ? optionsEstadosSelect.find(x => x.id == dataGrupo.estado) : optionsEstadosSelect[0],
    }});
    const { control, setValue, handleSubmit, getValues, formState: { errors } } = methods;

    const asignaciones = useWatch({ control, name: 'asignaciones' });

    const onClickGuardar = async (data) => {
        if(asignaciones.length == 0)  return dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes agregar al menos una segmentación' } });

        try {
            if(edit) {
                await gruposImpulsarService.updateGrupo({
                    id: dataGrupo.id,
                    nombre: data.nombre,
                    fechaInicio: dateToStringFormat(data.fecha[0]),
                    fechaFin: dateToStringFormat(data.fecha[1]),
                    estado: data.estado.id,
                    asignaciones: data.asignaciones
                });
            }else {
                await gruposImpulsarService.saveGrupo({
                    nombre: data.nombre,
                    proveedor,
                    fechaInicio: dateToStringFormat(data.fecha[0]),
                    fechaFin: dateToStringFormat(data.fecha[1]),
                    estado: data.estado.id,
                    asignaciones: data.asignaciones
                });
            }

            reload();
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    }

    const addAsignacion = () => {
        const segmentacion = getValues('segmentacion');
        if(!segmentacion) return;

        if(!asignaciones.some(asg => asg == segmentacion.id)) {
            setValue('asignaciones', [...asignaciones, segmentacion.id]);
            setValue('segmentacion', null);
        }else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'La segmentación ya se encuentra asignada' } });
        }
    }

    const deleteAsignacion = (id) => setValue('asignaciones', asignaciones.filter(asg => asg != id));

    const getNameSegmentaciones = (id) => {
        const segmentacion = segmentaciones.find(seg => seg.id == id);
        return "Segmentación_" + segmentacion?.text ?? '';
    }

    return (
        <FormProvider {...methods}>
            <div className="p-2 w-100">
                <Tooltip title="Guardar" aria-label="guardar" style={{position: "absolute", right: "3.5%", zIndex: 1}}>
                    <a onClick={handleSubmit(onClickGuardar, () => {})} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>
            
                <div className="w-100 row m-0 px-2">
                    <InputForm
                        inputProps={{ control }}
                        identificador="nombre" 
                        label="Nombre"
                        placeholder=""
                        required={true}
                        textUppercase={false}
                        className="px-2 col-3"
                        customError={errors.nombre ? "El campo no puede estar vacío" : null}
                    />
                    
                    <CalendarFormRange
                        inputProps={{ control }}
                        disabled={false}
                        identificador="fecha" 
                        label="Fecha de activación"
                        required={true}
                        className="w-auto mb-2"
                        customError={errors.fecha ? "El campo no puede estar vacío" : null}
                    />

                    <SelectFormVirtualize
                        isMulti={false}
                        inputProps={{ control }}
                        disabled={false}
                        showId={false}
                        identificador="estado"
                        label="Estado"
                        options={optionsEstadosSelect}
                        required={true}
                        className="px-2 col-2"
                        customError={errors.estado ? "El campo no puede estar vacío" : null}
                    />
                </div>

                <div className="px-3 mt-4 pt-1">
                    <div className="pt-2 px-2" style={{borderTop: "0.5px solid #D2D2D2"}}>
                        <strong style={{fontSize: "14pt"}}>Segmentaciones Asignadas:</strong>

                        <div className="d-flex align-items-center mt-3">
                            <SelectFormVirtualize
                                isMulti={false}
                                inputProps={{ control }}
                                disabled={false}
                                showId={false}
                                identificador="segmentacion"
                                label="Segmentaciones"
                                options={segmentaciones}
                                required={false}
                                className="px-2 col-4"
                            />

                            <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}}>
                                <a onClick={addAsignacion} className="icon-container-actions d-flex">
                                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                                </a>
                            </Tooltip>
                        </div>

                        <div className="p-2">
                            {asignaciones.length > 0 ? 
                                asignaciones.map(( asignacion, index ) => 
                                    <div key={index} className="w-100 row m-0 p-0 pl-4 d-flex align-items-center" style={{height: "40px"}}>
                                        <span className="d-block mb-1" key={index}>
                                            <strong style={{fontSize: "16px", fontWeight: "bold", marginBottom: "5px"}}>»</strong>&nbsp;&nbsp;{getNameSegmentaciones(asignacion)}
                                        </span>

                                        <Tooltip title="Eliminar" aria-label="eliminar" style={{marginLeft: "20px"}}>
                                            <a onClick={() => deleteAsignacion(asignacion)} className="icon-container-actions d-flex">
                                                <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                                                <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-trash fa-2x"/>
                                            </a>
                                        </Tooltip>
                                    </div>
                                )
                                : 
                                <div className="ml-5">
                                    <p>No hay segmentaciones asignadas</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </FormProvider>
    )
}

export default FormCRUDGrupos